import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { modalAlertStyle } from "../../styles/common/modal-alert";

export function ModalAlert({
  variant = "success",
  open,
  message,
  title,
  buttonTitle,
  onOk,
  onClose,
}: {
  variant?: string;
  open: boolean;
  message?: string;
  title?: string;
  buttonTitle?: string;
  onOk?: () => void;
  onClose?: () => void;
}) {
  const [isOpen, setIsOpen] = useState(open);

  const content = {
    success: { title: "Success", icon: "/assets/alert/success.png" },
    failed: { title: "Failed", icon: "/assets/alert/failed.png" },
    info: { title: "Info", icon: "/assets/alert/warning.png" },
  };

  const handleClose = (_, reason) => {
    if (reason === "backdropClick") return;
    onClose?.();
    setIsOpen(false);
  };

  const handleOk = () => {
    onOk?.();
    handleClose(null, "okClick");
  };

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      sx={modalAlertStyle.modalAlert}
      disableEnforceFocus
    >
      <Stack sx={modalAlertStyle.modalAlertContainer}>
        <Box
          component="img"
          src={content[variant].icon}
          sx={modalAlertStyle.modalAlertLogo}
        />
        <Stack sx={modalAlertStyle.modalAlertContent}>
          <Typography sx={modalAlertStyle.modalAlertTitle}>
            {title ? `${title}` : content[variant].title}
          </Typography>
          <Typography sx={modalAlertStyle.modalAlertDesc}>{message}</Typography>
        </Stack>
        <Button
          variant="contained"
          color="primary"
          sx={modalAlertStyle.modalAlertButton}
          onClick={handleOk}
        >
          {buttonTitle || "Ok"}
        </Button>
      </Stack>
    </Modal>
  );
}
